import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["onClick", "aria-label", "data-testid"]
const _hoisted_3 = { class: "ml-2 flex" }
const _hoisted_4 = ["data-testid"]

export interface FilterTag {
  // Precisa ser único no array: alimenta o `key` (junto com `type`) e o data-testid
  // do botão de remover. Consumidores com ids repetidos entre categorias devem
  // qualificá-los (ex: `unit-1`, `schedule-1`).
  id: string | number
  label: string
  type: string
  value?: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveFilters',
  props: {
    filters: {},
    showClearButton: { type: Boolean },
    testIdPrefix: { default: 'active-filters' }
  },
  emits: ["remove", "clearAll"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_ctx.showClearButton)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "flex flex-wrap gap-2 items-center",
        "data-testid": _ctx.testIdPrefix
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
          return (_openBlock(), _createElementBlock("span", {
            key: `${filter.type}-${filter.id}`,
            class: "inline-flex items-center rounded-full border border-primary30 px-3 py-1.5 text-[13px] font-medium text-primary30"
          }, [
            _createTextVNode(_toDisplayString(filter.label) + " ", 1),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.$emit('remove', filter)),
              class: "ml-2 text-primary-500 hover:text-primary-700 font-bold focus:outline-none",
              "aria-label": `Remover filtro ${filter.label}`,
              "data-testid": `${_ctx.testIdPrefix}-remove-${filter.id}-button`
            }, " × ", 8, _hoisted_2)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clearAll'))),
            class: "text-sm font-bold text-primary hover:text-primary-darken-1 transition-colors",
            "data-testid": `${_ctx.testIdPrefix}-clear-button`
          }, " Limpar filtros ", 8, _hoisted_4)
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})